<template>
    <v-dialog v-model="dialog" scrollable persistent :fullscreen="esMovil" max-width="600px">
        <template v-slot:activator="{}">
            <v-tooltip bottom :max-width="esMovil ? undefined : '300px'">
                <template v-slot:activator="{on}">
                    <v-btn icon @click="dialog = true" v-on="on">
                        <v-icon color="warning">mdi-alert</v-icon>
                    </v-btn>
                </template>
                <div>
                    {{$t('txt_tooltip')}}
                </div>
            </v-tooltip>
        </template>
        <v-card class="primary--text">
            <v-card-title class="pt-2 pb-1 pl-2 pr-1 font-weight-bold title primary white--text">
                {{$t('dialog_titulo')}}
                <v-spacer/>
                <v-btn icon right @click="dialog = false" color="white">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row class="my-2 body-1">
                        <v-col cols="12">
                            {{$t('txt_descrip')}}
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="error" text @click="dialog = false">
                    {{$t('cerrar') | capitalize}}
                </v-btn>
                <v-btn color="primary" text @click="solicitar()" :loading="solicitando">
                    {{$t('solicitar') | capitalize}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {HttpHelper} from "@/comunes/helpers/HttpHelper";
    import {MOSTRAR_SNACKBAR} from "@/store/store-app";

    export default {
        name: "BtnSolicitarProyecto",
        props: {
            proyectoId: {type: [String, Number], required: true},
        },
        data: () => ({
            dialog: false,
            solicitando: false,
        }),
        computed: {
            esMovil() {
                return this.$vuetify.breakpoint.smAndDown;
            }
        },
        methods: {
            solicitar() {
                this.solicitando = true;
                HttpHelper.get(`proyecto/${this.proyectoId}/recuperar`)
                    .then(() => {
                        this.dialog = false;
                        this.$store.commit(MOSTRAR_SNACKBAR, {
                            texto: this.$t("recuperado"),
                            color: "info"
                        });
                    })
                    .catch((error) => {
                        this.$store.commit(MOSTRAR_SNACKBAR, {
                            texto: error && error.mensaje ? error.mensaje : this.$t("recuperado_error"),
                            color: "error"
                        });
                    })
                    .finally(() => {
                        this.solicitando = false;
                    });
            }
        },
    }
</script>
<!--@formatter:off-->
<i18n>
    {
    "es": {
    "dialog_titulo": "Solicitar proyecto",
    "txt_tooltip": "Debido a la actualización de la aplicación de solconcer este proyecto no está disponble de manera inmediata, si deseas recuperarlo pulsa este botón.",
    "txt_descrip": "Debido a la actualización de la aplicación de solconcer este proyecto no está disponble de manera inmediata, para recuperarlo pulsa el botón Solicitar, la restauración del proyecto puede tardar un tiempo en hacerse efectiva",
    "recuperado": "¡Solicitud de recuperación enviada!",
    "recuperado_error": "Error al solicitar la recuperación del proyecto"
    }
    }
</i18n>
<!--@formatter:on-->
